// extracted by mini-css-extract-plugin
module.exports = {"SearchBox":"SearchBox_SearchBox__1sGkx"};